export const MIGRATION_WINDOW_DURATION = 7;

export const getLegacyMigrationTopbarMessage = (daysLeft: number): string =>
  `Your workspace upgrades to Text in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`;

export const getLegacyMigrationModalTitle = (daysLeft: number): string =>
  `Your workspace upgrades to Text in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`;

export const LEGACY_MIGRATION_COPY = {
  primaryAction: 'Try Text App now',
} as const;

export const LEGACY_MIGRATION_MODAL_COPY = {
  descriptionLine1: 'A new refreshed app will be here soon!',
  descriptionLine2: 'Chats, tickets, and AI Agent — all included in your plan.',
  primaryAction: "See what's changing",
} as const;

export enum LegacyMigrationEvent {
  ModalDisplayed = 'Migration Info Modal Displayed',
  ModalDismissed = 'Migration Info Modal Dismissed',
  ModalRemindMeLaterClicked = 'Migration Info Modal Remind Me Later Clicked',
  ModalPrimaryActionClicked = 'Migration Info Modal Primary Action Clicked',
  TopbarDisplayed = 'Migration Info Alert Displayed',
  TopbarDismissed = 'Migration Info Alert Dismissed',
  TopbarCtaClicked = 'Migration Info Alert Cta Clicked',
}
